import { Injectable } from '@angular/core';
import { Resource, DocumentResource, Service, DocumentCollection } from 'ngx-jsonapi';
import { Account } from './account';
import { DirectTransferAction } from './direct-transfer-action';

export class DirectTransfer extends Resource {
    public type: string = 'direct_transfers';
    public attributes: {
        received: string;
        payment_identification: string;
        amount: number;
        sent: boolean;
        amount_without_fee1: number;
        address: string;
        amount_without_fee2: number;
    } = {
        received: '',
        payment_identification: '',
        sent: false,
        amount_without_fee1: 0.0,
        amount_without_fee2: 0.0,
        address: '',
        amount: 0.0
    };

    public relationships: {
        account: DocumentResource<Account>;
        direct_transfer_actions: DocumentCollection<DirectTransferAction>;
    } = {
        account: new DocumentResource<Account>(),
        direct_transfer_actions: new DocumentCollection<DirectTransferAction>()
    };
}

@Injectable({
    providedIn: 'root'
})
export class DirectTransfers1Service extends Service<DirectTransfer> {
    public resource: typeof DirectTransfer = DirectTransfer;
    public type: string = 'direct_transfers1';

    public constructor() {
        super();
        this.register();
    }
}

@Injectable({
    providedIn: 'root'
})
export class DirectTransfers2Service extends Service<DirectTransfer> {
    public resource: typeof DirectTransfer = DirectTransfer;
    public type: string = 'direct_transfers2';

    public constructor() {
        super();
        this.register();
    }
}
